import { handleJsonResponse, handleFileUploadResponse, getFilterQuery,addSortingQuery } from "./api";
import config from '../config'; 
import { getUser } from '../auth';
import { upload } from "@testing-library/user-event/dist/upload";

async function getFileById (id, token) {
  const response = await fetch(`${config.API_URL}/files/${id}`,
  {
  headers: {
    Authorization: `Bearer ${token}`
  }
  });

  return await handleJsonResponse(response);
}

export async function getFilesById(fileIds) {
  const user = getUser();
  const token = user?.access_token;
  try {
    const fetchFilesPromises = fileIds.map(id => getFileById(id, token));
    return await Promise.all(fetchFilesPromises);
  } catch (error) {
  }

}

export async function getFiles(filters, sorting, start = 0, limit = 10) {
  const user = getUser();
  const token = user?.access_token;

  let filterQuery = getFilterQuery(filters);
  
  if (filterQuery.length > 0){
    filterQuery = "filter=" + filterQuery;
  }
  filterQuery = addSortingQuery(filterQuery, sorting);
  const response = await fetch(`${config.API_URL}/files?${filterQuery}start=${start}&limit=${limit}`,    
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return await handleJsonResponse(response);
}

export async function deleteFiles(files) {
  const user = getUser();
  const token = user?.access_token;
  const fileIds = files.map((file) => file.id);
  const data = JSON.stringify(fileIds);

  const response = await fetch(`${config.API_URL}/files/batch-archive`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: data
  });
  return await handleJsonResponse(response);

} 

export async function downloadFile(fileData) {
  
  const user = getUser();
  const token = user?.access_token;
  
  const response = await fetch(`${config.API_URL}/files/${fileData.id}/data`,    
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => response.blob())
  .then((blob) => {
    const fileUrl = window.URL.createObjectURL(blob);
    let alink = document.createElement('a');
    alink.href = fileUrl;
    alink.download = fileData.fileName;
    alink.click();
  });

}

export async function downloadFiles(files) {
  const user = getUser();
  const token = user?.access_token;
  const fileResponses = files.map((file) => 
  {
      return downloadFile(file)
  });
  
}

export async function deleteFile(fileId) {
  const user = getUser();
  const token = user?.access_token;
  return await changeState(fileId, "archive", token);
}

export async function uploadFiles(toBeUploadedFiles, updateStatus, updateMessage) {
  
  const user = getUser();
  const token = user?.access_token;
  
  const results = await Promise.all(toBeUploadedFiles.map(async (file, index) => {
    let fileId = "";
    try
    {
      
      const uploadData = {
        Mimetype: file.type === '' ? "application/octet-stream" : file.type,
        FileSize: file.size,
        FileName: file.name,
        SupportedMethods: ["OutOfBandHttpPost"]
      }
      updateStatus(index, "Pending");

      const response = await fetch(`${config.API_URL}/files/inputs/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(uploadData)
      });
      
      const newFileResponse = await handleJsonResponse(response);
      fileId = newFileResponse.id;

      const uploadingStatusResponse = await changeState(fileId, "Uploading", token); 

      const fileBlob = new Blob([file.file], {type: file.type});
      const putResponse = await fetch(`${newFileResponse.connectionString}`,{ 
        method: 'PUT',
        body: fileBlob,
        
        headers: {  
          'Content-Type': `${file.type}`,
          'Content-Length': `${file.size}`,
          'x-ms-blob-type': "BlockBlob", 
        }, 
      });

      const uploadFileResponse = await handleFileUploadResponse(putResponse);
      updateStatus(index, "uploadComplete");


      const statusChange = await changeState(fileId, "UploadComplete", token);
      index++;
      
      return {status: "success", message: `File uploaded successfully ${newFileResponse.id}`, id: newFileResponse.id};

    } catch(error){
      let message = "Error uploading file. No id returned";
      if(fileId)
      {
        const fileStatusData ={"type": "Failed"};
        const response = await postFileAction(fileId, fileStatusData, token).then((response) => {
          if(!response.ok)
          {
            return "Error uploading file and changing file state"
          }
          return "Error uploading file"});          
          message = response;
      }
      updateStatus(index, "error");
      updateMessage(index, message);
      index++;
      return {status: "error", message: message};
    }
      
  }));
  return results;  
}

export async function changeState(fileId, state, token) {
  const data = JSON.stringify({"type": state});
  const response = await postFileAction(fileId, data, token);
  
  return await handleJsonResponse(response);
}

export async function postFileAction(fileId, data, token) {
  const response = await fetch(`${config.API_URL}/files/${fileId}/actions`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: data
  });
  
  return response;
}